import React from 'react';
import css from './EndorsementsCard.module.css';
import { createResourceLocatorString } from '../../../../util/routes';

function EndorsementsCard(props) {
  const {
    cardImage,
    name,
    locationFlag,
    locationName,
    abbreviatedName,
    description,
    history,
    routeConfiguration,
    id,
  } = props;

  return (
    <div
      onClick={() => {
        history.push(
          createResourceLocatorString('ProfilePage', routeConfiguration, { id: id }, {})
        );
      }}
      className={css.endorsementsCard}
    >
      <div className={css.cardHead}>
        <div className={css.cardImage}>
          {cardImage ? <img src={cardImage} /> : <span>{abbreviatedName}</span>}
        </div>
        <div>
          <div className={css.name}>{name}</div>
          <div className={css.location}>
            {!locationFlag?.includes('null') && <img src={locationFlag} />}
            <span className={css.locationName}>{locationName}</span>
          </div>
        </div>
      </div>
      <p className={css.description}>{description}</p>
    </div>
  );
}

export default EndorsementsCard;
